import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Img extends Component {
  static propTypes = {
    defaultSrc: PropTypes.string.isRequired,
    src: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.instanceOf(Object),
    ]),
  }

  static defaultProps = {
    src: null,
  }

  state = {
    img: null,
  }

  handleError = () => {
    const { defaultSrc } = this.props;
    this.setState({ img: defaultSrc });
  }

  render() {
    const { src, defaultSrc, ...rest } = this.props;
    const { img } = this.state;
    return (
      <img
        src={img || src || defaultSrc}
        onError={this.handleError}
        alt=""
        {...rest}
      />
    );
  }
}

export default Img;
